import { render, staticRenderFns } from "./DocsForPrint.vue?vue&type=template&id=48bc7181"
import script from "./DocsForPrint.vue?vue&type=script&lang=js"
export * from "./DocsForPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports